<!--
  Decoupled Ariadne chat. The host is a full-viewport, click-through overlay boundary (pointer-events
  none) so it NEVER affects page layout or adds scroll. Closed: a bottom-right bubble. Open: a
  full-screen modal (dim backdrop + large centered dialog) hosting Ariadne's own /chat in an <iframe>.
  BOTH the bubble and the modal stay in the DOM (toggled with [hidden]) so the iframe is never
  unmounted — the conversation survives close/reopen. allow="microphone" delegates the mic permission.
-->
@if (configured) {
  <div class="ariadne-fab-boundary" [hidden]="isOpen()">
    <button
      type="button"
      class="ariadne-fab"
      cdkDrag
      cdkDragBoundary=".ariadne-fab-boundary"
      [cdkDragFreeDragPosition]="dragPosition()"
      (cdkDragEnded)="onDragEnded($event)"
      aria-label="Open Ariadne assistant"
      (click)="onBubbleClick()"
    >
      <mat-icon class="ariadne-fab__mark">auto_awesome</mat-icon>
    </button>
  </div>

  <div class="ariadne-modal-backdrop" [hidden]="!isOpen()" (click)="close()">
    <div
      class="ariadne-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Ariadne assistant"
      data-testid="ariadne-frame-panel"
      (click)="$event.stopPropagation()"
    >
      <header class="ariadne-frame-header">
        <span class="ariadne-frame-title">Ariadne</span>
        <button
          type="button"
          class="ariadne-frame-close"
          aria-label="Close assistant"
          (click)="close()"
        >
          ✕
        </button>
      </header>
      <iframe
        class="ariadne-frame-iframe"
        [src]="chatUrl"
        title="Ariadne chat"
        allow="microphone"
        referrerpolicy="origin"
      ></iframe>
    </div>
  </div>
}
